export default {
    407: '表单信息填写不符合',
    500: '服务器处理出现异常',
    509: '添加失败',
    510: '修改失败',
    511: '删除失败'
}